import React from "react"
import PropTypes from "prop-types"
import AddIcon from "@mui/icons-material/Add"
import { Fab, Tooltip } from "@mui/material"

const CompanyCreateFab = ({ onClick }) => (
    <Tooltip title="Cadastrar empresa">
        <Fab
            aria-label="Cadastrar empresa"
            onClick={onClick}
            sx={{
                position: "fixed",
                right: { xxxs: 16, md: 28 },
                bottom: { xxxs: 16, md: 28 },
                zIndex: (theme) => theme.zIndex.modal - 1,
                backgroundColor: "icon.main",
                color: "background.primary",
                "&:hover": { backgroundColor: "warning.main" },
                "&:focus-visible": {
                    outline: "2px solid #FFFFFF",
                    outlineOffset: 3,
                },
            }}
        >
            <AddIcon />
        </Fab>
    </Tooltip>
)

CompanyCreateFab.propTypes = {
    onClick: PropTypes.func.isRequired,
}

export default CompanyCreateFab
